module.exports = __webpack_public_path__ + "static/media/do-and-dont.e4e6063f.pdf";